import { Subject } from 'rxjs';

import {
  Component,
  Inject,
  OnDestroy,
  AfterViewInit,
  ChangeDetectorRef,
  HostListener,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnMou } from '@lib/api/entities';

@Component({
  selector: 'sn-mou-dialog',
  templateUrl: './mou-dialog.component.html',
  styleUrls: ['./mou-dialog.component.scss'],
})
export class MouDialogComponent implements OnDestroy, AfterViewInit {
  public mouThemplate: string;
  public buttonDisabled = true;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _dialogRef: MatDialogRef<MouDialogComponent>,
    private readonly _cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: SnMou,
  ) {}

  public ngAfterViewInit(): void {
    this.mouThemplate = this.data.mouTemplate;
    this._cd.detectChanges();
  }

  public aceptedMou(): void {
    this._dialogRef.close(true);
  }

  public close(): void {
    this._dialogRef.close(false);
  }

  public noAccepted(): void {
    this._dialogRef.close();
  }

  @HostListener('scroll', ['$event'])
  public onScroll(ev: any): void {
    const currentPosition = ev.target.offsetHeight + ev.target.scrollTop;
    // Add 1px tolerance to handle browser precision issues
    if (currentPosition >= ev.target.scrollHeight - 1) {
      this.buttonDisabled = false;
    }
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
